import type { PartDefinition } from "@rogue/rackbuilder"
import { CTM1, CTM1_ACCESSORIES, ATTACHMENTS } from "../../modelPaths"
import { CTTowerOptions } from "../../RackTypes"

export class CTM1Builder {
  constructor(private config: CTTowerOptions, private left?: boolean) {}

  public build(): PartDefinition {
    const isStandAlone = this.config.standAlone

    const bottomBaseHardware: PartDefinition = { mesh: `${CTM1}#bottom base hardware`, slots: {} }
    const topBaseHardware: PartDefinition = { mesh: `${CTM1}#top base hardware`, slots: {} }

    const cableRetainer: PartDefinition = { mesh: `${CTM1}#cable retainer`, slots: {} }
    const bottomCable: PartDefinition = { mesh: `${CTM1}#bottom cable ${this.config.height}h`, slots: {} }

    const bottomBandPegs: PartDefinition = { mesh: `${CTM1_ACCESSORIES}#bottom band pegs`, slots: {} }
    const topBandPegs: PartDefinition = { mesh: `${CTM1_ACCESSORIES}#top band pegs`, slots: {} }

    const shroud: PartDefinition = {
      mesh        : `${CTM1}#shroud ${this.config.height}`,
      slots       : {},
      adjustments : this.left ? [{ type: 'flip', axis: 'X'}] : [],
    }
    const weights300: PartDefinition = { mesh: `${CTM1}#weights 300`, slots: {} }
    const topWeightStack: PartDefinition = { mesh: `${CTM1}#top weight stack`, slots: { top_peg: this.config.bandPegs ? [topBandPegs] : [] } }

    const latBarAttachment: PartDefinition = { mesh: `${ATTACHMENTS}#${this.config.latBarSelection}`, slots: {}, materials: this.config.materials?.latpulldown }
    const trolleyAttachment: PartDefinition = { mesh: `${ATTACHMENTS}#${this.config.trolleySelection}`, slots: {} }
    const lowRowAttachment: PartDefinition = { mesh: `${ATTACHMENTS}#${this.config.lowRowSelection}`, slots: {}, offset: { z: 0.45 } }
    const seat: PartDefinition = { mesh: `${CTM1_ACCESSORIES}#seat`, slots: {}, offset: { y: -12 } }

    const latBarClip: PartDefinition = { mesh: `${ATTACHMENTS}#clip`, slots: { bottom: this.config.latBarSelection ? [latBarAttachment] : [] } }
    const trolleyClip: PartDefinition = { mesh: `${ATTACHMENTS}#clip`, slots: { bottom: this.config.trolleySelection ? [trolleyAttachment] : [] } }
    const lowRowClip: PartDefinition = { mesh: `${ATTACHMENTS}#bottom clip`, slots: { front: this.config.lowRowSelection ? [lowRowAttachment] : [] } }

    const latBarClevis: PartDefinition = { mesh: `${CTM1}#clevis`, slots: { bottom: latBarClip } }
    const trolley: PartDefinition = { mesh: `${CTM1}#carriage`, slots: { bottom: trolleyClip } }
    const topCable: PartDefinition = { mesh: `${CTM1}#top cable ${this.config.height}h`, slots: { clevis: latBarClevis } }
    const bottomCableExtension100: PartDefinition = { mesh: `${CTM1}#bottom extension ${this.config.height}h`, slots: {} }


    const backBase: PartDefinition = {
      mesh    : `${CTM1}#back base`,
      slots   : {},
      effects : isStandAlone ? {} : { opacity: 0.2 },
    }

    const CTM1Top: PartDefinition = {
      mesh  : `${CTM1}#top`,
      slots : {
        top_cable    : topCable,
        retainer     : this.config.height === '100' ? [cableRetainer] : [],
        bottom_cable : this.config.height === '100' ? [bottomCableExtension100] : [],
      },
    }

    const frontUpright: PartDefinition = {
      mesh  : `${CTM1}#front upright ${this.config.height}h`,
      slots : { top: CTM1Top, middle: trolley, seat: this.config.seatSelection ? [seat] : [] },
    }

    const backUpright: PartDefinition = {
      mesh    : `${CTM1}#back upright ${this.config.height}h`,
      slots   : {},
      effects : isStandAlone ? {} : { opacity: 0.2 },
    }

    const CTM1Base: PartDefinition = {
      mesh  : `${CTM1}#base`,
      slots : {
        back_base                                 : backBase,
        [`top_hardware_1_${this.config.height}h`] : isStandAlone ? [] : [topBaseHardware],
        [`top_hardware_2_${this.config.height}h`] : isStandAlone ? [] : [topBaseHardware],
        bottom_peg                                : this.config.bandPegs ? [bottomBandPegs] : [],
        front                                     : frontUpright,
        back                                      : [backUpright, bottomBaseHardware],
        bottom_hardware                           : bottomBaseHardware,
        cable                                     : bottomCable,
        bottom                                    : lowRowClip,
        [`shroud_${this.config.height}h`]         : shroud,
        [`weights_${this.config.weightStack}`]    : topWeightStack,
        top_weight_stack                          : this.config.weightStack === '300' ? [weights300] : [],
      },
    }

    return CTM1Base
  }
}
